import { useDispatch, useSelector } from "react-redux";
import {
  answerSingleChoiceQuestion,
  answerManyChoicesQuestion,
} from "../ducks/shoppingCartSlice";
import { isComboQuestion } from "../utils/questions";

/**
 * Estado de uma pergunta do produto e os handlers de cada opção. A marcação
 * muda entre o celular e o totem; a regra de resposta é esta, nos dois.
 */
export default function useQuestionState(question, orderUuid) {
  const dispatch = useDispatch();
  const answers =
    useSelector((state) => state.shoppingCart.answersByOrder[orderUuid]) || [];

  const { id: questionId, maxQtt } = question;
  const questionAnswers = answers.filter((a) => a.questionId === questionId);
  const qtt = questionAnswers.reduce((acc, a) => acc + a.qtt, 0);

  const answerMany = (optionId, optionQtt) =>
    dispatch(
      answerManyChoicesQuestion({
        questionId,
        orderUuid,
        optionId,
        qtt: optionQtt,
        question,
      }),
    );

  const statefulOptions = question.options.map((option) => {
    const answer = questionAnswers.find(
      (a) => a.optionId === option.id && a.qtt > 0,
    );
    const answeredQtt = answer ? answer.qtt : 0;
    const isChecked = answeredQtt === 1;
    return {
      ...option,
      answeredQtt,
      isChecked,
      onRadioClick: () =>
        dispatch(
          answerSingleChoiceQuestion({
            questionId,
            orderUuid,
            optionId: option.id,
            isChecked: !isChecked,
            question,
          }),
        ),
      onCheckboxClick: () => answerMany(option.id, isChecked ? 0 : 1),
      onIncrementClick: () => answerMany(option.id, answeredQtt + 1),
      onDecrementClick: () => answerMany(option.id, answeredQtt - 1),
    };
  });

  return {
    qtt,
    isSingleChoice: maxQtt === 1,
    isCombo: isComboQuestion(question),
    isIncrementDisabled: qtt >= maxQtt,
    statefulOptions,
  };
}
